import { combineReducers } from "redux"

import agreementSelection from "reducers/AgreementSelection"
import dAuth from "reducers/DAuth"
import agreementSelectionModalIsOpen from "reducers/AgreementSelectionModalIsOpen"
import api from "reducers/Api"
import snackbar from "reducers/Snackbar"
import timeout from "reducers/Timeout"

const rootReducer = combineReducers({
  agreementSelection,
  dAuth,
  agreementSelectionModalIsOpen,
  api,
  snackbar,
  timeout,
})

export default rootReducer
